import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { LegalTextWrapper, LegalTextContent } from "./_.styled";
import { PUBTYPE } from "../../constants/pubType";

const NCCN_URL = "https://www.nccn.org/";
const PrintLegalText = ({ pubType }) => {
  const { currentYear, prettyDate } = useMemo(() => {
    const date = new Date();
    const currentYear = date.getFullYear();
    const prettyDate = date.toLocaleDateString("en-US", { dateStyle: "long" });

    return { currentYear, prettyDate };
  }, []);

  return (
    <LegalTextWrapper data-testid="print-footer">
      {pubType === PUBTYPE.CHEMO_REGIMEN ? (
        <LegalTextContent>
          Referenced with permission from the NCCN. The NCCN Clinical Practice
          Guidelines in Oncology (NCCN Guidelines available at:{" "}
          <a href={NCCN_URL}>{NCCN_URL}</a>. Accessed {prettyDate}{" "}
          &copy;National Comprehensive Cancer Network, {currentYear}. Any
          clinician seeking to apply or consult any NCCN content is expected to
          use independent medical judgment in the context of individual clinical
          circumstances to determine any patient’s care or treatment. The NCCN
          makes no warranties of any kind whatsoever regarding the NCCN Content,
          their use and disclaims any responsibility for their application in
          any way.
        </LegalTextContent>
      ) : (
        <LegalTextContent>
          Published by EBSCO Information Services. Copyright &copy;{" "}
          {currentYear}, EBSCO Information Services. All rights reserved. No
          part of this may be reproduced or utilized in any form or by any
          means, electronic or mechanical, including photocopying, recording, or
          by any information storage and retrieval system, without permission.
        </LegalTextContent>
      )}

      <LegalTextContent>
        EBSCO Information Services accepts no liability for advice or
        information given herein or errors/omissions in the text. It is merely
        intended as a general informational overview of the subject for the
        healthcare professional.
      </LegalTextContent>
    </LegalTextWrapper>
  );
};

PrintLegalText.propTypes = {
  pubType: PropTypes.string.isRequired,
};

PrintLegalText.displayName = "PrintLegalText";
export default PrintLegalText;
